/**
 * File List Module - Работа со списком файлов и поиск
 */

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

    'use strict';

// Static import of DOM module - this ensures proper module resolution
import * as domModule from './file-list.dom/file-list-dom.js';

    const FileList = {};

    // Delegates to modular files
    import('/static/js/app/modules/files/file-list.utils.js').then(utils => { FileList._utils = utils; }).catch(()=>{});
    import('/static/js/app/modules/files/file-list.search.js').then(search => { FileList._search = search; }).catch(()=>{});
// DOM module is already loaded via static import
FileList._dom = domModule;
FileList._domPromise = Promise.resolve(domModule);

    let containerSelector = '#file-list-container';

    /**
     * Ищет файлы по условиям
     */
    FileList.searchFiles = function(filesList, matchConditions, options = {}) {
        if (FileList._search?.searchFiles) return FileList._search.searchFiles(filesList, matchConditions, options);
        return [];
    };

    /**
     * Создает функцию поиска для typeahead
     */
    FileList.createSearchMatcher = function(filesList) { return FileList._search?.createSearchMatcher ? FileList._search.createSearchMatcher(filesList) : () => {}; };

    /**
     * Обновляет прогресс-бар поиска
     */
    FileList.updateSearchProgress = function(percentage) { if (FileList._dom?.updateSearchProgress) return FileList._dom.updateSearchProgress(percentage); };

    /**
     * Обновляет счетчик найденных результатов
     */
    FileList.updateResultsCount = function(count, hasMore = false) { if (FileList._dom?.updateResultsCount) return FileList._dom.updateResultsCount(count, hasMore); };

    /**
     * Принудительно подсвечивает счетчик результатов поиска по имени при следующем обновлении
     */
    FileList.forceHighlightNameSearchCount = function() { if (FileList._dom?.forceHighlightNameSearchCount) return FileList._dom.forceHighlightNameSearchCount(); };

    /**
     * Подсвечивает совпадения в тексте
     */
    FileList.highlightMatches = function(text, matchConditions) { return FileList._search?.highlightMatches ? FileList._search.highlightMatches(text, matchConditions) : text; };

    /**
     * Фильтрует список файлов по различным критериям
     */
    FileList.filterFiles = function(filesList, filters = {}) { return FileList._utils?.filterFiles ? FileList._utils.filterFiles(filesList, filters) : filesList; };

    /**
     * Сортирует список файлов
     */
    FileList.sortFiles = function(filesList, sortBy = 'name', order = 'asc') { return FileList._utils?.sortFiles ? FileList._utils.sortFiles(filesList, sortBy, order) : filesList; };

// Для обратной совместимости
if (typeof window !== 'undefined') {
    window.FileList = FileList;
    window.fileListManager = FileList;

    window.myEach = function(strs, matchCond, full = false, colorize = false, test = false) {
        return FileList.searchFiles(strs, matchCond, {
            fullPath: full,
            colorize: colorize,
            test: test
        });
    };

    window.substringMatcher = function(strs) {
        return FileList.createSearchMatcher(strs);
    };
}

    /**
     * Initialize FileList module
     */
    FileList.init = function(config) {
        if (config && config.containerSelector) {
            containerSelector = config.containerSelector;
        }
        return this;
    };

    /**
     * Update files list
     */
    FileList.updateFiles = function(files) {
        if (debugMode === '1') {
                console.log('[FileList] updateFiles called', files?.length || 0);
            }
        if (debugMode === '1') {
                console.log('[FileList] FINAL FILES COUNT FOR USER:', files?.length || 0);
            }
        
        // Don't apply filters again in updateFiles - files are already filtered
        // Don't render here - let lazy-load manager handle it
        // Just trigger callback
        if (this._filesUpdateCallback) {
            this._filesUpdateCallback(files);
        }
        
        return this;
    };

    /**
     * Get all files
     */
    FileList.getAllFiles = function() {
        if (debugMode === '1') {
                console.log('[FileList] getAllFiles called');
            }
        try {
            if (window.filesStore && typeof window.filesStore.getFiles === 'function') {
                return window.filesStore.getFiles();
            }
        } catch(e) { /* noop */ }
        return [];
    };

    /**
     * Register callback for files update
     */
    FileList.onFilesUpdate = function(callback) {
        this._filesUpdateCallback = callback;
        return this;
    };

    /**
     * Set current page
     */
    FileList.setPage = function(page, pageSize) {
        if (debugMode === '1') {
                console.log('[FileList] setPage called', page, pageSize);
            }
        return this;
    };

    /**
     * Set files and render them
     */
    FileList.setFiles = function(files) {
        if (debugMode === '1') {
                console.log('[FileList] setFiles called', files?.length || 0);
            }
        // Do NOT override global store here; this method is for view updates only
        
        // Apply filters before rendering
        let filteredFiles = files || [];
        
        // Check if filter manager is available and apply filters
        if (window.filterManager && typeof window.filterManager.matchesFilters === 'function') {
            filteredFiles = files.filter(file => window.filterManager.matchesFilters(file));
            if (debugMode === '1') {
                console.log('[FileList] Files filtered by FilterManager', {
                original: files.length,
                filtered: filteredFiles.length
            });
            }
        }
        
        // Don't render here - let lazy-load manager handle it
        // Just trigger callback
        if (this._filesUpdateCallback) {
            this._filesUpdateCallback(files); // Send original files to callback
        }
        return this;
    };

    /**
     * Fetch summaries by keys via cache manager
     */
    FileList.fetchSummariesByKeys = async function(keys, summariesSource = null) {
        try {
            if (window.filesCacheManager && typeof window.filesCacheManager.getSummariesByKeys === 'function') {
                return await window.filesCacheManager.getSummariesByKeys(keys, summariesSource);
            }
        } catch(_) { /* noop */ }
        return new Array(Array.isArray(keys) ? keys.length : 0).fill(undefined);
    };

    /**
     * Render files in the container
     */
    FileList.renderFiles = async function(files, append = false) { 
    // DOM module is loaded via static import at the top of the file
        if (!FileList._dom) {
        console.error('[FileList] ❌ DOM module not available! This should not happen.');
                return this;
        }
        
        if (FileList._dom?.renderFiles) {
            try {
                await FileList._dom.renderFiles(files, append);
            } catch(err) {
                console.error('[FileList] ❌ Error rendering files:', err);
            }
            return this;
        } else {
            console.error('[FileList] ❌ FileList._dom.renderFiles not available!', {
                hasDom: !!FileList._dom,
                domKeys: FileList._dom ? Object.keys(FileList._dom) : []
            });
        }
        return this;
    };

    /**
     * Handle file click
     */
    FileList.handleFileClick = function(file) {
        if (debugMode === '1') {
                console.log('[FileList] File clicked:', file.n || file.name);
            }
        // Trigger custom event for file selection
        $(document).trigger('fileSelected', [file]);
    };

    /**
     * Format file size
     */
    FileList.formatFileSize = function(bytes) { return FileList._utils?.formatFileSize ? FileList._utils.formatFileSize(bytes) : '0 B'; };

    /**
     * Escape HTML
     */
    FileList.escapeHtml = function(text) { return FileList._utils?.escapeHtml ? FileList._utils.escapeHtml(text) : String(text); };

    /**
     * Get file by ID
     */
    FileList.getFileById = function(fileId) {
        if (debugMode === '1') {
                console.log('[FileList] getFileById called', fileId);
            }
        const files = (window.filesStore && typeof window.filesStore.getFiles==='function')
            ? window.filesStore.getFiles() : [];
        return files.find(file => file.id === fileId || file.name === fileId);
    };

    /**
     * Handle resize
     */
    FileList.handleResize = function() {
        if (debugMode === '1') {
                console.log('[FileList] handleResize called');
            }
        return this;
    };

// ES Module export
export const fileListManager = FileList;
